<template>
  <transition name="expansion">
    <div id="page-container" class="margin-total-amount">
      <router-view name="image-capture"></router-view>
      <router-view name="page-main" class="main-page"></router-view>
      <sub-page-container>
        <router-view name="page-sub" class="sub-page"></router-view>
      </sub-page-container>
      <cachalog-page-nav v-if="$store.getters.isMember"></cachalog-page-nav>
      <total-amount v-else :total="total"></total-amount>
      <router-view name="qrcode-reader">
        <qrcode-reader></qrcode-reader>
      </router-view>
      <router-view name="qrcode-order" class="has-text-white has-text-centered">
        <qrcode-order
          :page="page"
          :wishlist="wishlist"
          :user="user"
        />
      </router-view>
      <router-view name="qrcode-page" class="has-text-white has-text-centered">
        <div>
          <p class="is-cs-4">あなたのショップのQRコード</p>
        </div>
        <div class="qrcode">
          <c-qrcode :text="pageUrl"></c-qrcode>
        </div>
        <div>
          <p class="is-cs-4">{{ pageUrl }}</p>
          <p class="is-cs-2 has-text-weight-bold">長押しで保存</p>
        </div>
      </router-view>
      <section id="r18-screen" v-if="page.r18 && !sessionR18">
        <div class="has-text-centered has-text-white">
          <h1 class="is-cs-2">年齢確認</h1>{{ sessionR18 }}
          <p class="is-cs-3">18歳未満の方には不適切な表現内容が含まれる商品を扱っています。<br>18歳未満の方のアクセスはお断りします。<br>あなたは18歳以上ですか？</p>
          <div>
            <button class="button" @click="yesR18">はい</button>
            <button class="button" @click="noR18">いいえ</button>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import { fb } from './common.js'
import subPageContainer from './sub-page-container.js'
import cQrcode from './design/c-qrcode.vue'
import qrcodeOrder from '@/components/view/qrcode-order.vue'
import qrcodeReader from './view-model/qrcode-reader.vue'
import totalAmount from './view/total-amount.vue'
export default {
  components: {
    'sub-page-container': subPageContainer,
    'c-qrcode': cQrcode,
    'qrcode-order': qrcodeOrder,
    'qrcode-reader': qrcodeReader,
    'total-amount': totalAmount
  },
  props: ['pageId'],
  data: () => ({
    timeOutId: null,
    r18_: null
  }),
  computed: {
    ...mapState({
      cachalogUrl: 'cachalogUrl',
      user: 'user',
      page: 'page',
      wishlist: 'wishlist',
      wishlistOperationCounter: 'wishlistOperationCounter'
    }),
    pageUrl () {
      return this.cachalogUrl + this.page.id
    },
    total () {
      if (!this.wishlist) {
        return 0
      }
      const quantity = this.page.items.reduce((a, b, i) => {
        return a + (this.wishlist.items[i] || {quantiry: 0}).quantity
      }, 0)
      const amount = this.page.items.reduce((a, b, i) => {
        const quantity = (this.wishlist.items[i] || {quantiry: 0}).quantity
        return a + (b.price.value || 0) * quantity
      }, 0)
      return {
        amount,
        quantity
      }
    },
    wishlistItems () {
      if (!this.wishlist) {
        return []
      }
      return this.page.items.map((item, i) => {
        const quantity = (this.wishlist.items[i] || {quantiry: 0}).quantity
        return {...item, quantity}
      }).filter(item => item.quantity)
    },
    referenceNumber () {
      return btoa(this.user.uid).substr(0, 6).toUpperCase()
    },
    sessionR18 () {
      return sessionStorage.r18 === 'true' || this.r18_
    }
  },
  watch: {
    user (value) {
      /* if (this.pageId && (this.page.id != this.pageId || !this.page.id)) {
        this.$store.dispatch('fetchPage', this.pageId)
      // 認証前に数量入力した場合、認証後にwishlsit作成？タイミング、条件、吟味して
      //} else if (this.$store.getters.totalQuantity > 0) {
      //  this.$store.dispatch('updateWishlist', this.wishlist)
      } else */ if (!this.$store.getters.isMember) {
        this.$store.dispatch('fetchWishlistOnly', value.uid)
      }
    },
    wishlistOperationCounter () {
      clearTimeout(this.timeOutId)
      this.timeOutId = setTimeout(() => {
        if (this.$store.getters.totalQuantity > 0) {
          if (this.user.uid) {
            this.$store.dispatch('updateWishlist', this.wishlist)
          } else {
            (async () => {
              /*
               * Anonymousログイン時はローディング表示しない。
               * callback登録してAnonymousログイン＆ユーザ登録完了してからwishlist作成
               */
              this.$store.commit('signInAnonymous')
              await fb.auth().signInAnonymously()
              console.log('Anonymouse user is signed in.')
              this.$store.commit('enqueueCallback', () => {
                this.$store.dispatch('updateWishlist', this.wishlist)
              })
            })()
              .catch(error => console.error(error))
          }
        } else {
          this.$store.dispatch('deleteWishlist', this.wishlist)
        }
      }, 1000 * 3)
      /**
       * 数量の合計が１以上かつマイナスまたはnullが一つもなければUPDATE
       */
    }
  },
  methods: {
    yesR18 () {
      sessionStorage.r18 = 'true'
      this.r18_ = true
      this.$store.commit('enqueueHistories', this.page)
    },
    noR18 () {
      sessionStorage.r18 = 'false'
      this.$store.dispatch('removeUserHistory', this.pageId)
      this.$router.push({name: 'mypage'})
    }
  },
  created () {
    if (this.pageId && (this.page.id !== this.pageId || !this.page.id)) {
      this.$store.dispatch('fetchPage', this.pageId)
    }
  },
  destroyed () {
    this.$store.commit('discardPage')
  }
}
</script>

<style scoped>
.modal .body {
  background-color: #fff;
  width: 16rem;
  margin: auto;
}
.order {
  padding: 0 1.5rem 1.5rem;
}
.order p {
  margin-top: 0;
}
.order ul li {
  margin-bottom: 0;
}
.order ul li.total {
  margin-top: .5rem;
  padding-top: .5rem;
  border-top: dashed 1px #000;
}
.order ul li .amount {
  display: inline-block;
  width: 4rem;
}
.modal .reference-number {
  padding-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page-container.vue